
const state= {
    Items:[]
};

const getters = {
    Items: state => state.Items,
};

const actions = {
    async saveServiveCategory({commit}, params){
      return new Promise (( resolve, reject ) => {
          global.axios(`api/master/service-categories`, {
              method: "POST",
              data:  params,
              headers: {
                Accept: "application/json",
              }
          })
          .then(response => {
            resolve( response );
          })
          .catch(error => reject( error ));
      });
  },
    async updateServiveCategory({commit}, params){
    return new Promise (( resolve, reject ) => {
        global.axios(`api/master/service-categories/${params.id}`, {
            method: "PUT",
            data:  params,
            headers: {
              Accept: "application/json",
            }
        })
        .then(response => {
          resolve( response );
        })
        .catch(error => reject( error ));
    });
    },
    async removeServiveCategory({commit}, params){
    return new Promise (( resolve, reject ) => {
        global.axios(`/api/master/service-categories/${params.id}`, {
            method: "DELETE",
            headers: {
              Accept: "application/json",
            }
        })
        .then(response => {
          resolve( response );
        })
        .catch(error => reject( error ));
    });
    },
    getServiceCategories({commit}, params){
        return new Promise((resolve, reject) => {
            global.axios.get(`api/contracts/${params.contractId}/tree-service-categories/${params.categoryId}`)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    saveFirst({commit}, params){
      return new Promise((resolve, reject) => {
        global.axios(`/api/master/service-categories`, {
          method: "POST",
          data:  params,
          headers: {
            Accept: "application/json",
          }
      })
      .then(response => {
        resolve( response );
      })
      .catch(error => reject( error ));
      });
    },
}; 

const mutations = {

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}